export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "browse__availability--label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Now"])},
        "browse__toolTip--subheader": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toggle on to display items currently available to rent"])},
        "global__gotIt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Got it"])}
      }
    }
  })
}
